import { trackError } from '@if/core/telemetry';
export function reportErrorToConsole(error) {
    console.error(error);
}
/**
 * Report a caught error. Context belongs in `properties` — it rides on the
 * exception itself rather than arriving as a separate item to correlate by hand.
 */
export function reportErrorToServer(error, properties) {
    reportErrorToConsole(error);
    trackError(error, properties);
}
